import React, { useState, useEffect } from 'react'
import CKEditor from 'ckeditor4-react'
import { Icon, IconButton, Message, Modal, Row, Uploader } from 'rsuite'
import {
  requiredFiled,
  isValidators,
  getMaxLengthData,
  isValidFileType,
} from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ShowLimitLength from '../../utils/ShowLimitLength'
import { isEmpty } from 'lodash-es'

export default function CKEditorFromFull({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onChange = () => {},
  //toolbar = [['Bold', 'Italic', 'Maximize']],
  ...props
}) {
  const keyName = props.name || schema.name
  const dfValue = props.value || schema.value
  const maxLength = props.maxLength || getMaxLengthData(schema.validators)?.value
  const isBolder = props.isBolder || schema.isBolder

  const [textLength, setTextLength] = useState(dfValue ? dfValue.length : 0)
  // const [validators, setValidators] = useState(schema.validators)
  const validators = schema.validators || []
  const [fileError, setFileError] = useState()

  const fileSupportType = '.jpg, .jpeg, .png'

  useEffect(() => {
    countText(dfValue)
  }, [dfValue])

  const stripHtml = (html) => {
    if (typeof html !== 'string') return ''

    try {
      return html.replace(/<[^>]+>/g, '')
    } catch (error) {
      console.error('stripHtml error', error)
      return ''
    }
  }

  const onEditorChange = (evt) => {
    try {
      const data = evt?.editor?.getData?.() || ''

      // console.log('Data Length', data.length)

      setValue(keyName, data)

      clearErrors(keyName)

      countText(data)

      onChange(data)
    } catch (error) {
      console.error('CKEditor onChange error', error)
    }
  }

  // ## ใช้สำหรับแก้ไขเรื่องบันทึกตัวอักษรที่ติด html tag
  const countText = (str) => {
    // let text
    // if (str) {
    //   text = str.replace(/<(.|\n)*?>/g, '')
    // }

    if (typeof str !== 'string') {
      setTextLength(0)
      return
    }

    // const round0 = str?.replaceAll('&nbsp;', ' ')
    // const round1 = round0?.replaceAll('<p>', '')
    // const round2 = round1?.replaceAll('</p>', '')
    // const round3 = round2?.replaceAll('\n', '')

    const text = stripHtml(str)

    setTextLength(text?.length || 0)

    // if (schema?.validators?.length > 0) {
    //   // if (round3?.length >= maxLength && round3?.length <= maxLength) {
    //   if (text?.length <= maxLength) {
    //     const valid = [schema.validators[0]] || []
    //     setValidators(valid)
    //   } else {
    //     setValidators(schema.validators)
    //   }
    // }
  }

  const compressAndConvertToBase64 = async (
    file,
    maxWidth,
    maxHeight,
    quality = 0.7,
    type = 'image/jpeg'
  ) => {
    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.onload = (event) => {
        const img = new Image()
        img.src = event.target.result

        img.onload = () => {
          const canvas = document.createElement('canvas')
          let width = img.width
          let height = img.height

          // คำนวณขนาดใหม่
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width
              width = maxWidth
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height
              height = maxHeight
            }
          }

          canvas.width = width
          canvas.height = height

          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)

          // แปลงเป็น Base64
          const base64 = canvas.toDataURL(type, quality)

          resolve(base64)
        }
      }
      reader.readAsDataURL(file)
    })
  }

  const handleInsetFileToContent = async (file) => {
    //setInsertFileToContenErr()

    var editor
    for (var instanceName in CKEDITOR.instances) {
      editor = CKEDITOR.instances[instanceName]
    }

    const compressedBase64 = await compressAndConvertToBase64(
      file.blobFile,
      400,
      400,
      0.8
      //file.blobFile.type
    )

    let imageTag = `<img src="${compressedBase64}" alt="${file.blobFile.name}">`

    editor.insertHtml(` ${imageTag} `)
  }

  return (
    <>
      {schema && (
        <>
          <Row style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[keyName]} />
            {schema.label && (
              <p style={{ fontWeight: isBolder ? 'bolder' : undefined }}>
                {requiredFiled(schema.validators, schema.label)}
              </p>
            )}
            {schema.description && <CustomIconMessageInfo contents={schema.description} />}

            {fileError && (
              <Message
                closable
                showIcon
                type="error"
                description={fileError}
                onClose={() => {
                  setFileError('')
                }}
                style={{ marginBottom: 10 }}
              />
            )}

            <div style={{ textAlign: 'center' }}>
              <Uploader
                autoUpload={false}
                accept={fileSupportType}
                fileList={[]}
                onChange={(fileList) => {
                  if (!isEmpty(fileList)) {
                    let file = fileList[fileList.length - 1]

                    if (file.blobFile.size > 5 * 1024 * 1024) {
                      setFileError(`ขนาดไฟล์เกิน 5 MB`)

                      return
                    }

                    if (isValidFileType(file.blobFile.type, fileSupportType)) {
                      handleInsetFileToContent(file)
                      setFileError('')
                    } else {
                      setFileError(`ชนิดไฟล์ที่รองรับ ${fileSupportType}`)
                    }
                  }
                }}
              >
                <IconButton icon={<Icon icon="image" />}>แทรกรูปภาพ</IconButton>
              </Uploader>
            </div>

            <Controller
              key={keyName}
              name={keyName}
              control={control}
              rules={isValidators(validators)}
              defaultValue={dfValue || ''}
              render={(props) => {
                // enterMode
                return (
                  <>
                    <CKEditor
                      data={props.value}
                      config={{
                        versionCheck: false,
                        editorplaceholder: `${schema.label || ''} วางข้อความด้วย Ctrl+V`,
                        placeholder: schema.label,
                        height: '25em',
                        // เปิดปลั๊กอินช่วยวางจาก Word/Excel
                        extraPlugins:
                          'pastefromword,pastetext,clipboard,copyformatting,editorplaceholder,tabletools,tableselection,colorbutton,colordialog,forms,selectall',

                        // ✅ UX: เอาปุ่ม Paste ที่กดแล้วใช้ไม่ได้ออก ลดความงง
                        removeButtons: 'Paste,PasteText,PasteFromWord',
                        // แนะนำ: ให้ browser วางแบบ native (เสถียรสุด)
                        clipboard_handleImages: false,

                        // จัดการ Word/HTML ที่ติดมาด้วย
                        pasteFromWordRemoveFontStyles: true,
                        pasteFromWordRemoveStyles: true,

                        // ✅ Excel/Web: ต้อง “รับ table” แต่กัน junk อันตราย
                        // ถ้าอยากคง format เยอะ (ง่ายสุด) ใช้ allowedContent: true ต่อไปได้
                        // แต่เพื่อความนิ่ง แนะนำคุมแท็กหลัก ๆ ดังนี้:
                        // allowedContent:
                        //   'p h1 h2 h3 h4; ' +
                        //   'b strong i em u s; ' +
                        //   'ul ol li; ' +
                        //   'br hr; ' +
                        //   'table thead tbody tfoot tr th td;' +
                        //   'a[!href,target,rel]; ' +
                        //   'span;',
                        allowedContent: true,

                        // กันของอันตราย + กัน event handler
                        disallowedContent: 'script; *[on*]; iframe; object; embed;',
                        toolbar: [
                          {
                            name: 'clipboard',
                            items: [
                              'Undo',
                              'Redo',
                              '-',
                              'Cut',
                              'Copy',
                              'SelectAll',
                              '-',
                              'CopyFormatting',
                              'RemoveFormat',
                            ],
                          },
                          { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike'] },
                          {
                            name: 'paragraph',
                            items: [
                              'NumberedList',
                              'BulletedList',
                              '-',
                              'Outdent',
                              'Indent',
                              '-',
                              'JustifyLeft',
                              'JustifyCenter',
                              'JustifyRight',
                              'JustifyBlock',
                            ],
                          },
                          { name: 'insert', items: ['Table', 'HorizontalRule', 'SpecialChar'] },
                          {
                            name: 'forms',
                            items: ['Checkbox', 'Radio', 'TextField', 'Textarea'],
                          },

                          {
                            name: 'styles',
                            items: ['Styles', 'Format', '-', 'TextColor', 'BGColor'],
                          },
                          { name: 'tools', items: ['Maximize', 'ShowBlocks'] },
                        ],
                        // plugins:
                        //   'dialogui,dialog,a11yhelp,basicstyles,bidi,blockquote,notification,toolbar,panel,floatpanel,colorbutton,colordialog,xml,ajax,menu,contextmenu,copyformatting,div,editorplaceholder,resize,elementspath,enterkey,entities,popup,filetools,filebrowser,find,floatingspace,listblock,richcombo,fakeobjects,forms,format,horizontalrule,htmlwriter,wysiwygarea,indent,indentblock,indentlist,smiley,justify,menubutton,list,liststyle,magicline,maximize,pagebreak,removeformat,selectall,showblocks,showborders,specialchar,scayt,stylescombo,tab,table,tabletools,tableselection,undo,lineutils,widgetselection,widget',
                        // 'dialogui,dialog,about,a11yhelp,dialogadvtab,basicstyles,bidi,blockquote,notification,button,toolbar,clipboard,panelbutton,panel,floatpanel,colorbutton,colordialog,xml,ajax,templates,menu,contextmenu,copyformatting,div,editorplaceholder,resize,elementspath,enterkey,entities,exportpdf,popup,filetools,filebrowser,find,floatingspace,listblock,richcombo,font,fakeobjects,forms,format,horizontalrule,htmlwriter,iframe,wysiwygarea,image,indent,indentblock,indentlist,smiley,justify,menubutton,language,link,list,liststyle,magicline,maximize,newpage,pagebreak,pastetext,pastetools,pastefromgdocs,pastefromlibreoffice,pastefromword,preview,print,removeformat,save,selectall,showblocks,showborders,sourcearea,specialchar,scayt,stylescombo,tab,table,tabletools,tableselection,undo,lineutils,widgetselection,widget,notificationaggregator,uploadwidget,uploadimage',
                        contentsCss: [
                          'https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;600&display=swap',
                          'body { font-size: "1rem"; font-family: "Sarabun", sans-serif; }',
                        ],
                      }}
                      onChange={onEditorChange}
                    />
                  </>
                )
              }}
            />
          </Row>
          <ShowLimitLength textLength={textLength} maxLength={maxLength} />
        </>
      )}
    </>
  )
}
